import { render, staticRenderFns } from "./CrowdData.vue?vue&type=template&id=2af7b46a&scoped=true&lang=pug&"
import script from "./CrowdData.vue?vue&type=script&lang=js&"
export * from "./CrowdData.vue?vue&type=script&lang=js&"
import style0 from "./CrowdData.vue?vue&type=style&index=0&id=2af7b46a&prod&lang=sass&scoped=true&"
import style1 from "./CrowdData.vue?vue&type=style&index=1&id=2af7b46a&prod&lang=sass&scoped=true&"
import style2 from "./CrowdData.vue?vue&type=style&index=2&id=2af7b46a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2af7b46a",
  null
  
)

export default component.exports